module.exports = __webpack_public_path__ + "static/media/banner_og.399b7b34.png";